import { Badge, type BadgeProps } from "@mantine/core";
import type { RunPodJob } from "../../api/runpod";

type JobStatus = RunPodJob["status"];

// Exhaustive over the job status union - a new backend status is a compile error here.
const STATUS: Record<JobStatus, { color: string; label: string }> = {
  COMPLETED: { color: "teal", label: "Completed" },
  IN_PROGRESS: { color: "blue", label: "Processing" },
  IN_QUEUE: { color: "yellow", label: "In queue" },
  FAILED: { color: "red", label: "Failed" },
  CANCELLED: { color: "gray", label: "Cancelled" },
};

/** Color-coded job status badge. Single source of truth for status → color/label. */
export default function StatusBadge({ status, ...props }: { status: JobStatus } & BadgeProps) {
  const s = STATUS[status];
  if (s === undefined) throw new Error(`Unknown job status: ${status}`);
  return (
    <Badge color={s.color} variant="light" {...props}>
      {s.label}
    </Badge>
  );
}
